module.exports = __webpack_public_path__ + "img/page.fee3ee4d.png";